import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'
import { useFindLocaleText } from '../../text-localisation'

type InternalUserGalleryInfoVariantProps = {
  productCount: number
  searchTerm: string
  filters: { facetKey: string; group: string }[]
  promotionId?: string
  totalClickRankDocumentCount: number
  departments: DepartmentsEnum[]
}

const StyledList = styled.ul`
  ${s({
    position: 'absolute',
    top: '200px',
    right: 0,
    zIndex: 1,
    bgcolor: 'colorBackgroundSite',
    border: 1,
    borderColor: 'colorBodyText',
    color: 'colorBodyText',
    typography: 'typeBodyCaption',
    p: 5,
    mr: 5,
  })}
`

export const InternalUserGalleryInfoVariant: FC<
  InternalUserGalleryInfoVariantProps
> = ({
  productCount,
  searchTerm,
  filters,
  promotionId,
  totalClickRankDocumentCount,
  departments,
}) => {
  const filterElements = filters.map(entry => {
    return (
      <div key={`${entry.group}:${entry.facetKey}`}>
        {entry.group} : {entry.facetKey}
      </div>
    )
  })
  const localiseText = useFindLocaleText()

  return (
    <StyledList role="list">
      <li aria-label={`${localiseText('find.product_count')}${productCount}`}>
        <strong>{localiseText('find.product_count')}</strong>
        {productCount}
      </li>
      <li aria-label={`${localiseText('find.search_term')}${searchTerm}`}>
        <strong>{localiseText('find.search_term')}</strong>
        {searchTerm}
      </li>
      <li aria-label={`${localiseText('find.promotion_id')}${promotionId}`}>
        <strong>{localiseText('find.promotion_id')}</strong>
        {promotionId}
      </li>
      <li>
        <strong>Departments: </strong>
        {departments.join(', ')}
      </li>
      <li>
        <strong>Filters: </strong>
        {filterElements}
      </li>
      <li>
        <strong>Total click rank event count: </strong>
        {totalClickRankDocumentCount}
      </li>
    </StyledList>
  )
}
